import * as React from "react";
const Component = props => <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" viewBox="0 0 1000 1000" {...props}><rect width="100%" height="100%" fill="transparent" /><path d="M2830 5924c-369-34-643-95-933-210C867 5306 175 4419 24 3315c-25-178-24-530 0-710 69-512 251-972 541-1370C1036 589 1711 175 2535 29c152-27 603-38 779-19 1010 109 1899 714 2357 1604 162 315 258 621 311 991 20 142 17 601-5 745-88 559-297 1043-634 1463-477 594-1203 994-1983 1092-123 16-442 27-530 19m580-149c1161-174 2097-1010 2380-2125 57-222 71-336 77-595 8-360-17-583-98-864C5464 1132 4549 323 3465 156c-528-82-1041-26-1530 166-660 260-1208 765-1520 1403-211 432-297 843-281 1344 7 219 23 349 68 536 125 527 391 993 784 1375 150 146 256 232 409 334 421 279 892 442 1390 480 112 9 524-4 625-19" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.164 0 0 -.164 7.643 986.376)" /><path d="M2644 5681c-33-4-66-11-72-15-9-5-12-59-12-185v-177l-175-48c-97-26-181-46-189-43-7 3-41 54-76 114-75 129-116 183-139 183-54 0-688-364-717-412-3-5 35-79 85-164l91-156-136-131c-75-73-140-133-144-135-4-1-77 38-164 87l-156 90-90-134c-137-205-330-550-330-590 0-19 29-40 170-123 77-45 134-85 134-93-1-8-18-72-37-144-20-71-41-149-47-172l-11-43H261l-8-37c-4-21-8-198-8-393s4-372 8-392l8-38h184c166 0 184-2 189-17 50-172 95-346 91-353-3-4-59-38-125-76-67-38-135-80-152-94l-32-27 23-57c58-143 376-666 405-666 6 0 78 38 160 85s152 84 156 83c4-2 69-62 144-134l136-131-90-154c-49-85-90-157-90-161 0-33 666-418 723-418 21 0 61 54 145 196l65 112 66-19c36-11 119-33 183-51l118-31 2-180 3-181 30-9c42-13 436-21 642-12 132 5 177 11 188 22 12 12 15 49 15 187v172l178 47c98 26 182 47 188 47 5 0 27-30 49-67 86-150 144-233 164-233 67 0 721 382 721 421 0 6-38 76-85 156s-85 148-85 152c0 10 264 271 274 271 5 0 76-38 157-85 82-47 153-85 158-85 38 0 421 649 421 714 0 24-61 67-212 151-49 27-88 55-88 63 0 22 90 346 98 354 4 4 88 9 187 10l180 3 6 30c9 39 9 751 0 790l-6 30-180 3c-99 1-183 6-187 10-8 8-98 332-98 354 0 8 46 40 103 72 133 74 197 121 197 145 0 22-103 224-180 356-82 138-229 355-241 355-6 0-77-38-158-85s-152-85-157-85-70 61-144 135c-115 115-133 138-124 153 75 120 165 286 160 297-8 21-74 67-251 173-190 114-436 242-464 242-23 0-53-40-142-193-34-56-63-104-65-106s-87 18-189 44l-185 49v182c0 180 0 182-22 189-31 10-698 15-774 6m512-258c11-4 14-39 14-178v-172l58-7c102-12 363-77 512-128 80-27 155-51 166-54 19-5 32 12 104 133 46 76 88 144 95 151 10 12 36 0 145-63 124-74 131-79 125-104-4-14-41-86-83-160l-76-134 30-21c148-107 296-248 433-411 62-74 90-99 105-97 11 1 82 36 157 77s139 75 142 75c17 0 172-270 160-280-4-4-73-44-153-90-80-45-147-84-149-85-1-2 15-50 37-107 67-172 133-420 147-560 4-33 13-62 22-70 11-9 65-14 183-16l168-4 6-79c4-44 4-114 0-158l-6-79-168-4c-118-2-172-7-183-16-9-8-18-37-22-70-13-134-82-394-146-559-23-58-39-106-38-108 2-1 69-40 149-85 80-46 149-86 154-90 11-10-145-280-162-280-5 0-177 94-268 147l-41 23-76-92c-91-113-283-302-392-388-44-35-80-68-80-74s32-67 72-136c105-184 109-163-48-254-107-63-134-75-144-64-7 7-49 75-94 150-45 76-86 138-90 138s-59-18-122-41c-138-49-422-123-542-140l-87-13V673c0-171 0-173-22-177-63-13-141-17-220-10l-88 7-2 175-3 176-125 22c-155 27-360 80-510 133-63 23-118 41-122 41-3 0-43-62-87-137-45-76-85-144-90-152-7-11-33 0-127 54-66 37-127 74-136 82-22 19-16 34 73 189 38 67 69 126 69 131s-37 38-82 74c-114 87-263 233-370 362-49 59-92 107-95 107-4 0-76-36-161-81-144-75-155-79-167-62-13 17-72 116-128 214l-27 45 139 79c187 106 178 98 162 138-76 187-135 395-169 602l-19 110-175 3-176 2-6 31c-8 40-8 237 0 267 6 22 8 22 180 22s174 0 178 23c2 12 14 76 26 142 28 149 89 367 135 482 19 48 35 93 35 99 0 7-70 52-155 100l-155 88 26 45c57 98 116 197 129 214 13 18 22 14 168-62 85-45 157-81 160-81s46 48 95 108c103 123 239 256 364 357l86 70-14 35c-8 19-39 78-69 131-73 129-78 143-57 162 9 8 70 45 135 83 96 55 120 65 128 53 5-8 46-76 90-151 44-76 83-138 85-138s70 22 151 49c169 56 399 115 523 133l85 13 5 175 5 175 55 6c57 7 232 2 256-8" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.164 0 0 -.164 7.653 986.385)" /><path d="M3044 4885c-8-19 3-35 25-35 26 0 44 23 29 38-17 17-47 15-54-3" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.164 0 0 -.164 7.768 986.418)" /><path d="M2631 4881c-23-14-2-31 38-31 37 0 68 19 54 33-9 10-76 8-92-2" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.164 0 0 -.164 7.75 986.418)" /><path d="M2843 4774c-36-18-41-35-18-54 21-17 19-37-5-45-30-10-61 4-107 46-48 44-61 46-118 20-48-22-73-48-83-87-12-44-4-63 34-79 22-9 33-19 28-26-11-19-87-49-125-49-52 0-66 16-73 89-3 35-9 67-12 70-9 9-22-20-29-66-16-105 31-183 109-183 50 0 110 27 158 69 69 61 75 131 13 157-38 15-42 23-23 42 22 22 47 12 97-40l49-51 69 12c85 16 223 5 422-35 154-30 202-28 240 10 37 37 36 99-2 132-42 36-118 34-180-6-53-33-73-36-101-15-16 12-22 12-47 0-23-13-32-13-61-1-21 9-51 12-82 9l-48-6 7 41c5 34 3 42-14 51-28 15-60 13-98-5m561-120c9-3 16-13 16-21 0-13-9-15-50-10-64 8-83 19-50 28s65 10 84 3" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.164 0 0 -.164 7.739 986.422)" /><path d="M3855 4653c-50-70-125-220-125-252 0-39 42-78 102-96 27-8 66-27 86-43s51-36 67-45c31-15 120-106 189-191 47-59 75-71 120-52 66 28 113 124 74 150-26 16-51-3-61-48-5-20-15-36-23-36s-14 4-14 10c0 20-177 185-250 233-21 14-37 34-41 52-18 74-27 130-23 137 3 5 56 8 118 8 87 0 116 3 126 15 15 18 3 21-132 35-210 22-221 17-188-91 11-39 19-74 16-77-12-11-56 18-71 49-22 41-15 64 51 180 30 52 54 98 54 102s-9 7-20 7c-12 0-33-18-55-47" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.164 0 0 -.164 7.796 986.426)" /><path d="M1984 4626c-3-7-4-33-2-57 4-53 32-67 48-24 8 20 15 25 29 20 43-13 35 37-10 60-35 19-58 19-65 1" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.164 0 0 -.164 7.724 986.428)" /><path d="M3593 4588c-32-35-63-91-63-113 0-32 28-65 56-65 56 0 104 58 104 128 0 66-56 95-97 50m37-83c7-8 8-15 2-15-5 0-15 7-22 15s-8 15-2 15c5 0 15-7 22-15" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.164 0 0 -.164 7.788 986.43)" /><path d="M4030 4572c0-11 98-28 107-18 10 10 0 14-55 22-34 4-52 3-52-4" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.164 0 0 -.164 7.808 986.43)" /><path d="M2209 4558c-2-20-2-21 6-45 6-21 3-23-33-23s-41-3-51-31c-9-26-14-30-35-25-27 7-50-11-61-45-8-25-43-39-96-39-68 0-66-47 5-84 54-29 52-54-10-149-47-72-49-93-5-82 65 16 101 78 101 174v69l58 51c31 28 82 63 112 78 89 43 110 84 69 137-21 27-58 35-60 14" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.164 0 0 -.164 7.72 986.431)" /><path d="M2957 4446c-56-20-107-63-107-90q0-22.5 48-63c81-68 99-77 127-65 40 18 155 113 155 127 0 18-66 74-106 91-41 17-68 17-117 0" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.164 0 0 -.164 7.76 986.436)" /><path d="M4220 4350c-8-5-25-10-36-10-26 0-41-29-19-35 8-3 22-7 30-10 8-2 15-16 15-30 0-15 6-25 14-25 28 0 52 55 42 96-7 25-21 30-46 14" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.164 0 0 -.164 7.813 986.44)" /><path d="M2677 4323c-17-16-2-40 71-116 140-147 169-191 226-344 15-40 31-75 36-78 4-2 23 41 43 96 49 137 85 195 200 310 114 115 119 132 40 137-68 4-100-13-194-104-42-41-81-74-86-74-11 0-59 36-134 101-30 26-68 54-86 63-32 16-104 22-116 9" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.164 0 0 -.164 7.752 986.441)" /><path d="M1704 4288c-7-11 21-40 62-64 18-10 18-12 1-37-26-40-62-45-96-13-65 62-106-2-65-103 14-36 14-42-1-73-28-55-122-175-159-203-20-15-53-29-76-32-22-3-40-10-40-15 0-6 14-23 31-39 70-65 138-22 269 170 43 64 108 151 145 194 58 70 65 82 65 122 0 62-37 105-90 105-21 0-42-5-46-12m-34-183c0-8-4-15-9-15-13 0-22 16-14 24 11 11 23 6 23-9" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.164 0 0 -.164 7.697 986.442)" /><path d="M2480 4260c0-6 43-95 95-198 79-154 101-208 126-305 73-284 84-469 75-1210l-6-538 45-20c50-22 94-19 117 8 10 13 14 169 16 802 2 483-1 818-7 868-19 152-127 369-234 471-98 92-227 161-227 122" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.164 0 0 -.164 7.745 986.443)" /><path d="M3440 4239c-77-45-218-190-257-264q-78-151.5-93-318c-11-133-25-1512-16-1599 7-65 8-67 42-78 42-14 97-6 115 17 17 20 27 373 28 1039l1 462 45 170c51 196 44 176 146 392 43 91 79 174 81 185 5 32-30 29-92-6" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.164 0 0 -.164 7.769 986.444)" /><path d="M4424 4216c-8-21 3-36 27-36 15 0 20 6 17 22-4 27-35 37-44 14" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.164 0 0 -.164 7.824 986.445)" /><path d="M1421 4072c-11-21 3-52 24-52 16 0 31 43 20 59-10 17-33 13-44-7" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.164 0 0 -.164 7.701 986.45)" /><path d="M4484 4051c-63-46-164-161-164-187 0-41 70 7 157 109 84 96 87 137 7 78" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.164 0 0 -.164 7.82 986.451)" /><path d="M1760 3931c-5-11-17-27-26-35-16-16-13-46 4-46 16 0 64 70 58 85-8 21-23 19-36-4" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.164 0 0 -.164 7.714 986.457)" /><path d="M4526 3908c-16-9-18-19-12-78 5-43 3-71-3-75-6-3-30 12-54 35-47 43-67 49-87 25-28-34 28-117 87-128 39-7 96 18 116 52 10 17 17 50 17 81 0 76-25 110-64 88" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.164 0 0 -.164 7.822 986.458)" /><path d="M2033 3870c-31-12-29-44 4-116l27-59 6-409 5-408 124-65c166-86 157-97 153 179-2 238 5 284 45 294 57 15 57 15 64-322 4-201 10-319 18-338 7-16 27-46 44-66 18-20 48-57 66-83 37-55 56-59 65-16 10 51 7 784-4 909-17 187-44 255-144 358-65 68-134 107-232 132-80 21-202 26-241 10" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.164 0 0 -.164 7.725 986.46)" /><path d="M3735 3871c-68-17-185-98-250-173-51-60-93-152-104-228-17-113-18-1030-2-1030 14 0 64 53 119 123l47 62 11 317c8 229 14 321 24 333 18 22 57 19 70-6 7-11 15-115 20-233 9-213 18-266 43-266 13 0 197 98 230 122 16 12 18 47 27 368 13 464 14 481 46 530 47 71 16 91-144 89-59-1-120-4-137-8" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.164 0 0 -.164 7.781 986.46)" /><path d="M4174 3566c-17-8-40-27-52-42-37-53-44-109-46-346-1-266-2-263 89-263s87-13 97 341c5 168 8 307 6 309-13 12-69 12-94 1" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.164 0 0 -.164 7.81 986.472)" /><path d="M1773 3544c-17-7-18-555-2-602 11-34 31-42 101-42 69 0 71 8 76 251 5 236-5 295-61 355-31 34-84 51-114 38" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.164 0 0 -.164 7.715 986.473)" /><path d="M4055 2795c-143-31-297-117-407-228-136-138-285-394-295-508-6-56-5-59 21-69 39-14 82-12 118 6 23 12 40 37 75 112 64 138 139 246 235 338 122 117 215 167 257 137 29-20 24-28-137-195-223-232-304-365-243-398 11-5 45-10 75-10 48 0 60 4 91 32 20 17 55 59 77 92 93 138 181 219 326 303 115 65 215 94 352 102 101 5 115 8 118 24 5 26-38 69-134 133-192 128-354 167-529 129" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.164 0 0 -.164 7.78 986.503)" /><path d="M1712 2780c-126-33-255-103-338-184-41-39-74-76-74-82 0-15 34-24 96-24 84 0 222-28 302-62 151-63 322-204 414-342 64-95 74-104 132-111 28-4 67-3 86 2 29 8 35 14 38 40 4 37-29 106-99 209-58 86-119 149-195 199-113 75-142 113-112 143 41 41 147-14 274-142 102-103 180-212 234-330 21-45 47-89 58-100 30-26 105-33 137-12s32 47 1 129c-95 252-299 490-519 604-155 81-290 101-435 63" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.164 0 0 -.164 7.696 986.504)" /><path d="M4603 2415c-207-37-333-107-506-281-111-111-152-171-143-208 6-25 99-106 120-106 14 0 52 40 130 138 96 119 221 206 356 246 30 9 120 21 200 27 80 5 149 14 153 18 11 11-16 64-60 118-51 64-106 74-250 48" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.164 0 0 -.164 7.805 986.52)" /><path d="M1235 2386c-38-17-67-49-95-104-35-68-29-72 107-72 129 0 207-15 305-56 136-57 259-160 340-286 28-43 57-78 63-78 22 0 125 117 125 142 0 38-37 88-137 186-204 199-333 260-583 276-71 5-103 3-125-8" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.164 0 0 -.164 7.689 986.52)" /><path d="M2933 1870c-44-27-63-68-63-139 0-49 4-65 25-89 71-85 182-80 249 11 27 36 28 132 2 172-42 64-147 86-213 45" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.164 0 0 -.164 7.76 986.541)" /><path d="M2385 1859c-152-22-270-81-358-178-59-66-101-153-127-265-26-109-24-156 8-172 53-26 873-27 899 0 14 14 10 283-5 298-10 10-82 14-292 18-153 3-281 8-285 12-16 15 9 48 53 70 43 21 64 23 268 28 269 8 274 9 274 98 0 66-5 77-43 91-33 13-304 13-392 0" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.164 0 0 -.164 7.72 986.542)" /><path d="M3226 1848c-11-42-6-124 8-144 13-18 31-19 238-24 206-5 226-7 269-28 53-26 84-56 74-71-4-7-97-11-279-11-347 0-321 14-321-174q0-135 12-147c28-28 796-37 868-9 41 16 45 25 45 106 0 137-55 259-170 375-130 130-199 149-551 149-185 0-187 0-193-22" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.164 0 0 -.164 7.775 986.542)" /><path d="M2936 1324c-78-105-137-204-130-216 3-5 34-21 68-37 40-18 73-42 90-64 15-19 33-38 41-41s40 19 74 49c53 48 107 75 149 75 19 0 25 26 11 52-17 33-126 175-173 226-21 23-45 42-52 42-8 0-43-39-78-86" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.164 0 0 -.164 7.758 986.56)" /></svg>;
export default Component;
export { Component as ReactComponent };